// ============================================================
// About.js - About section with text on left, image on right
// ============================================================

import React from "react";

function About() {
  return (
    <section className="about" id="about-us">
      {/* Left: Text */}
      <div className="about-text">
        <h2>About</h2>
        <p>
          WHANI was established to bridge the gap between national-level project
          planning and local-level execution in island territories. We bring together
          local knowledge, professional expertise, and a commitment to safety and
          sustainability.
        </p>
        <p>
          Our deep understanding of the unique challenges faced in the Andaman &
          Nicobar Islands enables us to deliver comprehensive solutions that meet
          the highest standards of quality and compliance.
        </p>
        <div style={{ textAlign: "center", marginTop: "36px" }}>
          <a href="#contact" className="btn-primary" style={{ padding: "14px 40px", borderRadius: "4px", background: "#3b55f5" }}>
            Know more
          </a>
        </div>
      </div>

      {/* Right: Image */}
      <div className="about-image">
        <img
          src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=500&q=80"
          alt="WHANI team working on project planning"
        />
      </div>
    </section>
  );
}

export default About;
